export enum SmsDeliveryStatus {
  RUNNING = 'RUNNING',
  SENT = 'SENT',
  DONE = 'DONE',
  RECEIVED = 'RECEIVED',
  ANSWERED = 'ANSWERED',
  FAILED = 'FAILED',
  ERROR = 'ERROR',
  ABORTED = 'ABORTED',
}

export function adaptDeliveryStatus(status: string): string {
  switch (status) {
    case SmsDeliveryStatus.RUNNING:
    case SmsDeliveryStatus.SENT:
      return SmsDeliveryStatus.RUNNING;
    case SmsDeliveryStatus.DONE:
    case SmsDeliveryStatus.RECEIVED:
    case SmsDeliveryStatus.ANSWERED:
      return SmsDeliveryStatus.DONE;
    case SmsDeliveryStatus.ABORTED:
    case SmsDeliveryStatus.ERROR:
    case SmsDeliveryStatus.FAILED:
      return SmsDeliveryStatus.FAILED;
    default:
      break;
  }
}
